
import moment from 'moment';
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import {
  Connection,
  ProgressDetails as ProgressDetailsType,
} from '@/types';
import AttachmentStatusLabel from '@/components/AttachmentStatusLabel.vue';
import TooltipStatusLabel from '@/components/TooltipStatusLabel.vue';

moment.locale('it');

@Component({
  components: {
    AttachmentStatusLabel,
    TooltipStatusLabel,
  },
})
export default class ProgressDetails extends Vue {
  @Prop(Object) readonly connection: Connection | null | undefined;
  @Prop(Object) readonly details!: ProgressDetailsType | null;

  loading = false

  get connectionId() {
    return this.connection?.id ?? 'unknown';
  }

  isAnObject(value: unknown): boolean {
    return typeof value === 'object';
  }
}

